<div class="container" *ngIf="finishedLoadingUsers">
    <div class="row marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Notizen für {{this.currentUser.person.displayName}}</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="noteForm">
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <textarea matInput formControlName="note" rows="8" cols="50"></textarea>
                                <mat-error>
                                    Notiz darf nicht leer sein
                                </mat-error>
                            </mat-form-field>
              

                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editAccountNote()">Änderungen speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>


    <div class="row marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Datenschutzeinstellungen von {{this.currentUser.person.displayName}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="legalForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <label>
                                <mat-checkbox class="example-margin" formControlName="data_processing_state"
                                    [checked]="this.legalForm.getRawValue().data_processing_state"
                                    (change)="saveProperties('data_processing_state')">
                                    Zustimmung Newsletter
                                    <p>(Letzte Änderung: {{this.data_processing_state?.lastModified| date:'dd.MM.yyyy
                                        HH:mm:ss' }})</p>
                                </mat-checkbox>
                                <mat-hint>

                                </mat-hint>
                            </label>
                        </div>
                        <div class="col-sm-12">
                            <label>
                                <mat-checkbox class="example-margin" formControlName="agreed_participation"
                                    [checked]="this.legalForm.getRawValue().agreed_participation"
                                    (change)="saveProperties('agreed_participation')">
                                    Zustimmung Teilnahmebedingungen
                                    <p>(Letzte Änderung: {{this.agreed_participation?.lastModified| date:'dd.MM.yyyy
                                        HH:mm:ss'}})</p>
                                </mat-checkbox>
                            </label>
                        </div>

                        <div class="col-sm-12">
                            <label>
                                <mat-checkbox class="example-margin" formControlName="agreed_privacy"
                                    [checked]="this.legalForm.getRawValue().agreed_privacy"
                                    (change)="saveProperties('agreed_privacy')">
                                    Zustimmung Datenschutzbedingungen
                                    <p> (Letzte Änderung: {{this.agreed_privacy?.lastModified| date:'dd.MM.yyyy
                                        HH:mm:ss'}})</p>
                                </mat-checkbox>
                            </label>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>


    <!-- <div class="row marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Aktivierte Zusatzfunktionen für {{this.currentUser.person.displayName}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="activeServicesForm">
                    <div class="row" formGroupName="services">
                        <div class="col-sm-4" *ngFor="let serviceCheckbox of serviceCheckboxOptions; let i=index">
                            <label>
                                <mat-checkbox class="example-margin" [value]="serviceCheckbox"
                                    [checked]="serviceCheckbox.checked" (change)="activateService(serviceCheckbox.obj)">
                                    {{serviceCheckbox.name}}
                                </mat-checkbox>
                            </label>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>



    <div class="row marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Gesperrte Dienste für {{this.currentUser.person.displayName}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="lockedServicesForm">
                    <div class="row">
                        <div class="col-sm-4">
                            <label>
                                <mat-checkbox class="example-margin" formControlName="vtw">
                                    Aktionswelt
                                </mat-checkbox>
                            </label>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div> -->








</div>

<div class="container" *ngIf="!finishedLoadingUsers">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>